import './footer.scss';
import React, {useEffect, useState} from "react";
import {default as _} from "../../../helpers/Translate"
import {connect} from "react-redux";
import T from "../../../shared/component/t/T"

function Footer(props) {
    const [language, setLanguage] = useState(props.language)
    const [direction] = _.direction();

    useEffect(() => {
        setLanguage(props.language)
    }, [props.language]);

    return (
        <>
            <div className={'footer'} style={{ direction: direction }}>
                <div className={"footer__content"}>
                    <T token={"copyright"} language={language}/>
                </div>
            </div>
        </>

    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
}

export default connect(mapStateToProps)(Footer);
